var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.443 10.577a4.327 4.327 0 100-8.654 4.327 4.327 0 000 8.654zM12.173 30.54l-1.335 3.112h-6.03a2.885 2.885 0 000 5.769h6.982a4.318 4.318 0 003.976-2.622l.793-1.85-.962-.568c-1.561-.922-2.71-2.287-3.425-3.841zm24.366-8.427H32.57l-2.349-4.8c-1.127-2.303-3.196-3.987-5.57-4.592l-6.407-1.905a8.617 8.617 0 00-7.287 1.545l-3.576 2.74a2.885 2.885 0 003.51 4.578l3.578-2.74c.692-.532 1.572-.722 2.278-.554l1.325.393-3.377 7.878a5.784 5.784 0 002.371 7.24l7.66 4.522-2.476 7.909a2.884 2.884 0 105.506 1.723l2.852-9.11a4.345 4.345 0 00-1.951-4.903l-5.52-3.258 2.822-7.056 1.827 3.735a4.354 4.354 0 003.886 2.424h4.867a2.885 2.885 0 000-5.769z",
    stroke: "#91C300",
    strokeWidth: 2.5
  })));
}

export default SvgRun;